import React from 'react';
import FormsRow from '../FormsRow/FormsRow';
import FormsFieldset from '../FormsFieldset/FormsFieldset';
import FormRadio from '../FormRadio/FormRadio';

export enum FormRadioGroupOrientation {
  vertical = 'vertical',
  horizontal = 'horizontal',
}

type Radio = {
  name: string;
  type: string;
  value: string;
  required: boolean;
  disabled?: boolean;
};

type FormRadioGroupType = {
  id: string;
  legend?: string;
  helpText?: string;
  orientation: FormRadioGroupOrientation;
  radios: Radio[];
  selected?: string;
  labels: any;
  onChange: any;
  // isRadioDisabled: func,
};

const FormRadioGroup = function ({
  legend,
  helpText,
  orientation,
  radios,
  selected,
  labels,
  onChange,
  id,
}: FormRadioGroupType) {
  return (
    <FormsFieldset id={`form-radio-group-${id}`} legend={legend} helpText={helpText}>
      <FormsRow>
        <div className={`form-radio-group form-radio-group--${orientation}`}>
          {radios.map((element: Radio) => {
            return (
              <FormRadio
                id={id}
                key={`${element.name}-${element.value}`}
                type={element.type}
                name={element.name}
                labelTitle={labels[element.value]}
                value={element.value}
                checked={selected === element.value && !element.disabled}
                required={element.required}
                disabled={element.disabled}
                onChange={(event: any) => onChange(event.target.name, event.target.value)}
              />
            );
          })}
        </div>
      </FormsRow>
    </FormsFieldset>
  );
};

/* for debugging purposes, to have a name in stack trace instead of unspecific
 _type */
FormRadioGroup.displayName = 'FormRadioGroup';

export default FormRadioGroup;
